<template>
  <div class="sidebar-content sidebar-content--jacket">
    <h1 class="sidebar-title">Jacket Style</h1>

    <div
      class="jacket-block"
      :class="{active: jacketType === JACKET_TYPE.SET_IN}"
      @click="onChangeJacketType(JACKET_TYPE.SET_IN)"
    >
      <img
        src="@/assets/images/jacket-front-sub-setIn-classic.png"
        alt="Set In Sleeves"
        class="jacket-block__img"
      >
      <div class="jacket-block__label">Set In</div>
      <div class="hover-overlay"></div>
    </div>

    <div
      class="jacket-block"
      :class="{active: jacketType === JACKET_TYPE.RAGLAN}"
      @click="onChangeJacketType(JACKET_TYPE.RAGLAN)"
    >
      <img
        src="@/assets/images/jacket-front-sub-raglan-classic.png"
        alt="Raglan Style Sleeves"
        class="jacket-block__img"
      >
      <div class="jacket-block__label">Raglan</div>
      <div class="hover-overlay"></div>
    </div>
  </div>

</template>

<script>
import { JACKET_TYPE } from '@/common/constants';

export default {
  name: 'JacketStyleSidebar',

  data () {
    return {
      JACKET_TYPE
    };
  },

  computed: {
    jacketType () {
      return this.$store.getters['design/getJacketType'];
    }
  },

  methods: {
    onChangeJacketType (jacketType) {
      this.$store.dispatch('design/setJacketType', jacketType);
    }
  }
};
</script>

<style scoped>
  .jacket-block {
    cursor: pointer;
    padding: 15px 0;
    position: relative;

    .hover-overlay {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background: rgba(216, 216, 216, 0.2);
      display: none;
    }

    &:hover,
    &.active {
      .hover-overlay {
        display: block;
      }
    }
  }

  .jacket-block__img {
    height: 120px;
  }

  .jacket-block__label {
    margin-top: 10px;
    text-transform: uppercase;
    font-size: 18px;
    font-weight: 500;
  }
</style>
